var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46509 0L10.2612 5.52786H16.0735L11.3713 8.94427L13.1674 14.4721L8.46509 11.0557L3.76281 14.4721L5.55892 8.94427L0.856636 5.52786H6.66898L8.46509 0Z",
    fill: "#FBD61E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStars);
export default __webpack_public_path__ + "static/media/ReviewStars.7162492d4611ed729c1cf8f1c26c05f3.svg";
export { ForwardRef as ReactComponent };